import TextContent from './TextContent';
import LiveResults from './LiveResults';

/* ── Loading skeletons ── */

function SkeletonText() {
  return (
    <div className="text-content">
      <div className="text-hero" style={{ background: 'rgba(14,165,233,0.08)' }}>
        <div className="skeleton skeleton-line" style={{ width: '75%', height: 28, marginBottom: '1rem' }} />
        <div className="skeleton skeleton-line narrow" style={{ height: 14 }} />
      </div>
      <div style={{ padding: '1.5rem 2rem' }}>
        {[1, 2, 3].map((i) => (
          <div key={i} className="skeleton skeleton-line wide" style={{ marginBottom: '.75rem' }} />
        ))}
        <div className="skeleton skeleton-line medium" />
      </div>
    </div>
  );
}

/* ── Main component ── */

function ContentDisplay({ results, loading, searchParams, onRetryModel, onNextLesson }) {
  const { format, subject } = searchParams || {};

  if (loading) {
    return (
      <section className="content-section">
        <div className="content-header">
          <h2>
            {format === 'live'  ? '🔴 Searching the web live…' :
             format === 'audio' ? '🎧 Preparing your audio lesson…' :
                                  'Generating your lesson…'}
          </h2>
        </div>
        {format === 'live' ? (
          <div className="live-skeleton">
            <div className="skeleton skeleton-line" style={{ width: '60%', height: 24, marginBottom: '1rem' }} />
            <div className="skeleton skeleton-line wide" style={{ marginBottom: '.5rem' }} />
            <div className="skeleton skeleton-line wide" style={{ marginBottom: '.5rem' }} />
            <div className="skeleton skeleton-line medium" />
          </div>
        ) : (
          <SkeletonText />
        )}
      </section>
    );
  }

  if (!results) return null;

  /* Text */
  if (format === 'text') {
    return (
      <section className="content-section">
        <div className="content-header">
          <h2>Your Bite-Lesson</h2>
        </div>
        <TextContent
          lesson={results}
          subject={subject}
          onRetryModel={onRetryModel}
          onNextLesson={onNextLesson}
          searchParams={searchParams}
          autoPlay={false}
        />
      </section>
    );
  }

  /* Audio — AI-generated text read aloud */
  if (format === 'audio') {
    return (
      <section className="content-section">
        <div className="content-header">
          <h2>🎧 Audio Lesson</h2>
          <span className="result-count">AI-generated · auto-playing</span>
        </div>
        <TextContent
          lesson={results}
          subject={subject}
          onRetryModel={onRetryModel}
          onNextLesson={onNextLesson}
          searchParams={searchParams}
          autoPlay={true}
        />
      </section>
    );
  }

  /* Live */
  if (format === 'live') {
    return (
      <section className="content-section">
        <LiveResults data={results} subject={subject} />
      </section>
    );
  }

  return null;
}

export default ContentDisplay;
